module.exports = __webpack_public_path__ + "img/shift-scheduling.9ca051f1.webp";